import CompactProgressBar from './CompactProgressBar'
export default CompactProgressBar
